import { Injectable, Scopes } from '@visiba/instantiation';
import { withTranslation } from './with_translation';

export enum KioskSessionFlow {
	Vcs,
	QrCode,
}

export const SUPPORTED_LANGUAGES = ['sv', 'en', 'no'] as const;
export const SUPPORTED_COUNTRIES = ['SE', 'GB', 'NO'] as const;
type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];
type SupportedCountry = (typeof SUPPORTED_COUNTRIES)[number];

@Injectable({ scope: Scopes.Singleton })
export class SessionController {
	public sessionId: string | null = null;
	public sessionUrl: string | null = null;
	public sessionFlow: KioskSessionFlow | null = null;
	public languageCode: SupportedLanguage = 'en';
	public countryCode: SupportedCountry = 'SE';

	constructor() {}

	public async submit({ name }: { name: string }, flow: KioskSessionFlow): Promise<void> {
		const [givenName, ...rest] = name.split(' ');
		const familyName = rest.join(' ');

		const fetchWithRetry = async (attempt: number = 1): Promise<Response> => {
			try {
				const response = await fetch(`${process.env.NODE_ENV === 'development' ? 'https://localhost:7189' : ''}/api/demo`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({
						flow,
						givenName,
						familyName: familyName === '' ? 'NoFamilyName' : familyName,
						languageCode: this.languageCode,
						countryCode: this.countryCode,
					}),
				});

				if (!response.ok) {
					throw new Error('Network response was not ok');
				}

				return response;
			} catch (error) {
				if (attempt >= 2) {
					throw withTranslation('start-session.button-next-error');
				}

				return fetchWithRetry(attempt + 1);
			}
		};

		const response = await fetchWithRetry();
		const responseText = await response.text();

		this.sessionFlow = flow;
		this.sessionId = responseText.split('/').pop() ?? 'unknown';
		this.sessionUrl = `${responseText}?languageCode=${this.languageCode}`;
	}

	public setLocale(locale: string): void {
		const [languageCode, countryCode] = locale.split('-');
		if (SUPPORTED_COUNTRIES.includes(countryCode as SupportedCountry)) {
			this.countryCode = countryCode as SupportedCountry;
		}
		if (SUPPORTED_LANGUAGES.includes(languageCode as SupportedLanguage)) {
			this.languageCode = languageCode as SupportedLanguage;
		}
	}
}
